import { rem } from "polished";
import styled from "styled-components";
import media from "styled-media-query";

import { themes } from "styles";

export const Container = styled.div`
  padding: 24px 0 16px;

  display: flex;
  align-items: center;

  ${media.greaterThan("huge")`
    padding: 32px 0 24px;
  `}
`;

export const Icon = styled.div`
  transform: translateY(1px);

  padding-right: 4px;

  line-height: 0;
  font-size: ${rem("14px")};
  color: ${themes.palletes.primary};

  ${media.greaterThan("huge")`
    font-size: ${rem("20px")};
  `}
`;

export const Title = styled.p`
  padding-right: 8px;

  font-weight: 500;
  font-size: ${rem("11px")};
  color: ${themes.text.high};
  font-family: ${themes.fonts.title};

  ${media.greaterThan("huge")`
    font-size: ${rem("15px")};
  `}
`;

export const Line = styled.div`
  height: 1px;

  flex: 1;

  background-color: #edf3f5;
`;
